// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { sync } from "vuex-router-sync";
import store from "@/store";
import service from "@/service";
import apiSet from "@/apiSet";
import moment from "moment";
import utils from "@/plugins/utils";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import "@/plugins/editor";
import "@/plugins/material";
import "@/plugins/mixin";
import "@/plugins/globalComponents";
import "@/assets/styles/global.styl";

import router from "./router";
import App from "./App";

sync(store, router);

Vue.config.productionTip = false;
Vue.prototype.$config = process.env;
Vue.prototype.$utils = utils;
Vue.prototype.$apis = apiSet;
Vue.prototype.$moment = moment;
Vue.prototype.$service = service;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
  },
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js